import { GetterTree } from 'vuex'
import { State } from './state'
import { ProductAggregatedStatDeklaracjeSum } from "@/store/modules/statsDeklaracje/types";


export function aggregatedStatsDeklaracjeSumUpdating (state: State): boolean {
    return state.aggregatedStatsDeklaracjeSumUpdating;
}

export function aggregatedStatsDeklaracjeSum (state: State): Array<ProductAggregatedStatDeklaracjeSum> {
    return state.aggregatedStatsDeklaracjeSum;
}

export function detailedStatsDeklaracjeLoading (state: State): boolean {
    return state.detailedStatsDeklaracjeLoading;
}

export function detailedStatsDeklaracje (state: State): Array<object> {
    return state.detailedStatsDeklaracje;
}

export default <GetterTree<State, any>> {
    aggregatedStatsDeklaracjeSumUpdating,
    aggregatedStatsDeklaracjeSum,
    detailedStatsDeklaracjeLoading,
    detailedStatsDeklaracje
}
